import { GenericChartBuilder } from '@/composables/charts/influx-charts/chart-builders/GenericChartBuilder'
import { GeneralChartTimeSetup } from '@/composables/charts/influx-charts/chart-serialization/ChartTimeSetup'
import { BaseSerializedTimeSeriesChart } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import Highcharts from 'highcharts'

export abstract class TimeSeriesChartBuilder extends GenericChartBuilder {
  protected _timeSetup: GeneralChartTimeSetup

  get timeSetup(): GeneralChartTimeSetup {
    return this._timeSetup
  }

  protected constructor(serialized: BaseSerializedTimeSeriesChart) {
    super(serialized)
    if (serialized.timeSetup) this._timeSetup = GeneralChartTimeSetup.fromSerialized(serialized.timeSetup)
    else this._timeSetup = GeneralChartTimeSetup.default()
    this._timeSetup.attachUpdateListener(this.timeSetupUpdated.bind(this))
  }

  timeSetupUpdated() {
    if (this.paused) return
    this.load().catch()
  }

  serialize(): BaseSerializedTimeSeriesChart {
    return {
      ...super.serialize(),
      timeSetup: this._timeSetup.serialize(),
      yAxisType: this.yAxisType,
    }
  }
  abstract getRenderChartType(): string

  openDataPointClickDialog(event: Highcharts.PointerEventObject) {
    this.dataPointClickListeners.forEach(listener => listener(event))
  }
}
